export const categories = [
  { id: 'guochanju', name: '国产剧', slug: 'guochanju', icon: 'ri-tv-line' },
  { id: 'hanju', name: '韩剧', slug: 'hanju', icon: 'ri-heart-line' },
  { id: 'meiju', name: '美剧', slug: 'meiju', icon: 'ri-global-line' },
  { id: 'dongman', name: '动漫', slug: 'dongman', icon: 'ri-rocket-line' },
  { id: 'zongyi', name: '综艺', slug: 'zongyi', icon: 'ri-emotion-laugh-line' },
];

export const videos = [
  {
    id: 1,
    title: '庆余年第二季',
    category: 'guochanju',
    year: 2024,
    rating: 8.5,
    region: '中国大陆',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    description: '范闲经历了生死考验后，再次踏入京都的漩涡之中。在更加复杂的朝堂斗争中，他以智慧和勇气应对来自各方的挑战，同时揭开更多关于自己身世的秘密。',
    episodes: 36,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20period%20drama%20poster%2C%20elegant%20male%20lead%20in%20traditional%20hanfu%20robe%2C%20dramatic%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20palace%20background%20with%20soft%20bokeh%2C%20film%20poster%20style%2C%20clean%20composition%2C%20professional%20photography&width=600&height=800&seq=qnyd2-poster-001&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%2C%20grand%20imperial%20palace%20courtyard%20at%20sunset%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20silhouette%20of%20ancient%20Chinese%20architecture%2C%20cinematic%20wide%20shot%2C%20warm%20atmospheric%20lighting%2C%20film%20quality&width=1600&height=700&seq=qnyd2-hero-001&orientation=landscape',
    featured: true,
  },
  {
    id: 2,
    title: '与凤行',
    category: 'guochanju',
    year: 2024,
    rating: 7.9,
    region: '中国大陆',
    actors: ['赵丽颖', '林更新'],
    director: '邓科',
    description: '灵界碧苍王沈璃为掌握自己的命运，在逃婚过程中意外受伤坠落凡间，被上古神行止所救。两人在凡间共同经历磨难，彼此相知相守。',
    episodes: 39,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%2C%20beautiful%20female%20lead%20in%20flowing%20ethereal%20costume%2C%20magical%20glowing%20elements%2C%20soft%20dreamy%20lighting%2C%20romantic%20atmosphere%2C%20film%20poster%20design%2C%20elegant%20composition&width=600&height=800&seq=yfx-poster-002&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20drama%20landscape%2C%20magical%20ancient%20Chinese%20setting%20with%20floating%20islands%2C%20ethereal%20mist%20and%20golden%20light%2C%20cinematic%20wide%20shot%2C%20dreamy%20atmosphere%2C%20warm%20sunset%20tones&width=1600&height=700&seq=yfx-hero-002&orientation=landscape',
    featured: true,
  },
  {
    id: 3,
    title: '眼泪女王',
    category: 'hanju',
    year: 2024,
    rating: 8.2,
    region: '韩国',
    actors: ['金秀贤', '金智媛'],
    director: '张荣佑',
    description: '讲述皇后集团的法务理事白贤宇与百货女王洪海仁结婚三年后，面临婚姻危机却重新发现彼此爱情的故事。',
    episodes: 16,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%2C%20elegant%20couple%20in%20modern%20luxury%20setting%2C%20emotional%20expression%2C%20soft%20romantic%20lighting%2C%20clean%20minimalist%20design%2C%20film%20poster%20style%2C%20warm%20neutral%20tones&width=600&height=800&seq=ylnw-poster-003&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%2C%20modern%20Seoul%20cityscape%20at%20twilight%2C%20luxury%20apartment%20interior%20with%20warm%20lighting%2C%20cinematic%20wide%20shot%2C%20emotional%20atmosphere%2C%20soft%20golden%20hour%20tones&width=1600&height=700&seq=ylnw-hero-003&orientation=landscape',
    featured: true,
  },
  {
    id: 4,
    title: '墨雨云间',
    category: 'guochanju',
    year: 2024,
    rating: 7.6,
    region: '中国大陆',
    actors: ['吴谨言', '王星越', '陈鑫海'],
    director: '侣皓吉吉',
    description: '县令之女薛芳菲经历人生巨变后，受中书令之女姜梨所托，顶替其身份重返京城，在肃国公萧蘅等人的帮助下，逐步揭露真相。',
    episodes: 40,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20poster%2C%20mysterious%20female%20lead%20in%20dark%20elegant%20hanfu%2C%20dramatic%20shadows%20and%20contrast%2C%20rainy%20atmosphere%2C%20film%20poster%20style%2C%20moody%20cinematic%20lighting&width=600&height=800&seq=myyj-poster-004&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20rainy%20garden%20scene%2C%20traditional%20pavilion%20in%20mist%2C%20dark%20dramatic%20sky%2C%20cinematic%20landscape%2C%20moody%20atmosphere%2C%20Chinese%20ink%20painting%20aesthetic&width=1600&height=700&seq=myyj-hero-004&orientation=landscape',
    featured: false,
  },
  {
    id: 5,
    title: '繁花',
    category: 'guochanju',
    year: 2023,
    rating: 8.7,
    region: '中国大陆',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    description: '九十年代的上海，青年阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上人来人往，霓虹闪烁中上演着一段段传奇故事。',
    episodes: 30,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%2C%20stylish%20man%20in%20vintage%20suit%2C%20neon%20lights%20and%20retro%20atmosphere%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20film%20poster%20design%2C%20warm%20golden%20and%20red%20tones&width=600&height=800&seq=fh-poster-005&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%2C%20colorful%20neon%20signs%2C%20retro%20Chinese%20city%20vibe%2C%20wet%20street%20reflections%2C%20cinematic%20wide%20shot%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20and%20red%20tones&width=1600&height=700&seq=fh-hero-005&orientation=landscape',
    featured: false,
  },
  {
    id: 6,
    title: '背着善宰跑',
    category: 'hanju',
    year: 2024,
    rating: 8.8,
    region: '韩国',
    actors: ['边佑锡', '金惠允'],
    director: '金泰烨',
    description: '因疲惫生活而决定结束生命的女主，被顶级明星善宰的一通电台电话拯救。她穿越回过去，成为善宰的同桌，开始了一段改变命运的奇幻浪漫之旅。',
    episodes: 16,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20youth%20romance%20drama%20poster%2C%20young%20couple%20in%20school%20uniform%2C%20sweet%20nostalgic%20vibe%2C%20cherry%20blossom%20atmosphere%2C%20soft%20pastel%20lighting%2C%20film%20poster%20style%2C%20warm%20spring%20tones&width=600&height=800&seq=bzszp-poster-006&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20drama%20scene%2C%20cherry%20blossom%20tree%20lined%20path%2C%20spring%20sunlight%2C%20youthful%20romantic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20soft%20warm%20lighting&width=1600&height=700&seq=bzszp-hero-006&orientation=landscape',
    featured: false,
  },
  {
    id: 7,
    title: '仙逆',
    category: 'dongman',
    year: 2024,
    rating: 8.4,
    region: '中国大陆',
    actors: [],
    director: '石头熊',
    description: '平凡少年王林因意外获得天逆珠，从此踏上修仙之路。以平庸的资质，凭借坚韧不拔的意志与聪明才智，一步步走向巅峰。',
    episodes: 78,
    status: '连载中',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20cultivation%20fantasy%20poster%2C%20young%20swordsman%20in%20flowing%20robe%20with%20spiritual%20energy%2C%20epic%20mountain%20landscape%2C%20dramatic%20lighting%2C%20anime%20style%20art%2C%20clean%20composition&width=600&height=800&seq=xn-poster-007&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20cultivation%20fantasy%20landscape%2C%20misty%20mountains%20with%20floating%20temples%2C%20magical%20energy%20auras%2C%20sunrise%20lighting%2C%20cinematic%20wide%20shot%2C%20anime%20art%20style&width=1600&height=700&seq=xn-hero-007&orientation=landscape',
    featured: false,
  },
  {
    id: 8,
    title: '辐射',
    category: 'meiju',
    year: 2024,
    rating: 8.3,
    region: '美国',
    actors: ['艾拉·珀内尔', '沃尔顿·戈金斯'],
    director: '乔纳森·诺兰',
    description: '在一个几乎被核战争摧毁的未来世界里，避难所的和平居民被迫回到被辐射污染的地表，发现一个复杂而怪诞的宇宙正在等待着他们。',
    episodes: 8,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci%20fi%20drama%20poster%2C%20survivor%20in%20wasteland%20with%20gas%20mask%2C%20ruined%20city%20background%2C%20dramatic%20orange%20sky%2C%20film%20poster%20style%2C%20cinematic%20composition&width=600&height=800&seq=fs-poster-008&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20wasteland%20landscape%2C%20ruined%20city%20skyline%2C%20dramatic%20orange%20and%20brown%20sky%2C%20desolate%20atmosphere%2C%20cinematic%20wide%20shot%2C%20sci%20fi%20aesthetic&width=1600&height=700&seq=fs-hero-008&orientation=landscape',
    featured: false,
  },
  {
    id: 9,
    title: '奔跑吧第八季',
    category: 'zongyi',
    year: 2024,
    rating: 7.2,
    region: '中国大陆',
    actors: ['李晨', '郑恺', '白鹿', '周深'],
    director: '姚译添',
    description: '全新一季跑男来袭，固定嘉宾阵容升级，更有飞行嘉宾惊喜加盟。经典游戏环节与全新挑战交织，欢乐与感动并存。',
    episodes: 12,
    status: '连载中',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20in%20colorful%20casual%20outfits%2C%20fun%20energetic%20vibe%2C%20bright%20studio%20lighting%2C%20entertainment%20show%20style%2C%20cheerful%20composition&width=600&height=800&seq=bpb-poster-009&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20scene%2C%20colorful%20theme%20park%20setting%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20fun%20vibrant%20colors&width=1600&height=700&seq=bpb-hero-009&orientation=landscape',
    featured: false,
  },
  {
    id: 10,
    title: '鱿鱼游戏第二季',
    category: 'hanju',
    year: 2024,
    rating: 7.5,
    region: '韩国',
    actors: ['李政宰', '李秉宪', '孔刘'],
    director: '黄东赫',
    description: '成奇勋在赢得鱿鱼游戏后，决定揭开游戏背后的组织真相。他重新回到那个充满死亡的游戏世界，却发现一切比他想象的更加复杂和危险。',
    episodes: 7,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%2C%20mysterious%20masked%20figures%20in%20colorful%20uniform%2C%20dark%20suspenseful%20atmosphere%2C%20geometric%20patterns%2C%20film%20poster%20style%2C%20bold%20contrast%20lighting&width=600&height=800&seq=yyyx-poster-010&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20scene%2C%20mysterious%20staircase%20with%20colorful%20geometric%20walls%2C%20suspenseful%20atmosphere%2C%20dark%20cinematic%20lighting%2C%20wide%20shot%2C%20dramatic%20shadows&width=1600&height=700&seq=yyyx-hero-010&orientation=landscape',
    featured: false,
  },
  {
    id: 11,
    title: '完美世界',
    category: 'dongman',
    year: 2024,
    rating: 8.6,
    region: '中国大陆',
    actors: [],
    director: '汪成果',
    description: '石昊为寻找亲生父母踏上征程，在荒域中历经磨难，与各路天骄争锋。以无畏之心横扫一切敌，缔造属于自己的完美世界。',
    episodes: 182,
    status: '连载中',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20poster%2C%20young%20warrior%20with%20glowing%20spiritual%20power%2C%20epic%20battle%20scene%2C%20dynamic%20action%20pose%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20vibrant%20energy%20effects&width=600&height=800&seq=wmsj-poster-011&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20battlefield%20landscape%2C%20warriors%20clashing%20with%20magical%20powers%2C%20dramatic%20sky%20with%20energy%20bursts%2C%20cinematic%20wide%20shot%2C%20anime%20art%20style&width=1600&height=700&seq=wmsj-hero-011&orientation=landscape',
    featured: false,
  },
  {
    id: 12,
    title: '龙之家族第二季',
    category: 'meiju',
    year: 2024,
    rating: 7.8,
    region: '美国',
    actors: ['艾玛·达西', '马特·史密斯'],
    director: '阿兰·泰勒',
    description: '坦格利安家族的内战愈演愈烈。黑党与绿党之间的权力斗争席卷了整个维斯特洛大陆，龙焰即将燃遍天际。',
    episodes: 8,
    status: '已完结',
    posterUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20drama%20poster%20with%20dragon%20silhouette%2C%20medieval%20fantasy%20aesthetic%2C%20golden%20dragon%20against%20dark%20background%2C%20epic%20fantasy%20film%20poster%20style%2C%20dramatic%20fire%20and%20smoke%20effects&width=600&height=800&seq=lzjz-poster-012&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20medieval%20castle%20on%20cliff%2C%20dragon%20flying%20in%20stormy%20sky%2C%20dramatic%20lightning%20and%20fire%2C%20cinematic%20wide%20shot%2C%20dark%20fantasy%20atmosphere&width=1600&height=700&seq=lzjz-hero-012&orientation=landscape',
    featured: false,
  },
];

export const featuredVideos = videos.filter(v => v.featured);

export const getVideosByCategory = (slug: string) => {
  return videos.filter(v => v.category === slug);
};

export const getVideoById = (id: number) => {
  return videos.find(v => v.id === id);
};

export const getRelatedVideos = (video: typeof videos[0], limit = 6) => {
  return videos
    .filter(v => v.id !== video.id && v.category === video.category)
    .slice(0, limit);
};